module.exports = __webpack_public_path__ + "static/img/yljh1.27378d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/yljh1.png
// module id = 19KB
// module chunks = 55